import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import {Popup} from "../../../../ui/popup/popup";

interface ICrediteTextPopup {
}
export const CrediteTextPopup = (props : ICrediteTextPopup) => {

    const dispatch = useAppDispatch();
    const IsAnnual = useAppSelector((store) => store.IsAnnual);

    const closeHandler = () => {
            dispatch(
                rootActions.main({
                    CreditTextPopupShow:false
                })
            )

    }

    return (
        <Popup width="400px" height="auto" close={ closeHandler }>
            <div className="px-4 py-10">
            {IsAnnual && <div>
                As an Ultimate Annual subscriber, you get 30 Waves Online Mastering credits annually after each successful payment. These credits <b>roll over</b> and remain available as long as you’re actively subscribed: <a href="/legal/ultimate-subscription-online-mastering-benefit">See terms & conditions</a>.
            </div>}
            {!IsAnnual && <div>
                As an Ultimate Monthly  subscriber, you get 2 Waves Online Mastering credits monthly after each successful payment. These credits <b>roll over</b> and remain available as long as you’re actively subscribed: <a href="/legal/ultimate-subscription-online-mastering-benefit">See terms & conditions</a>.
            </div>}
            </div>
        </Popup>

    )
};